<template>
  <div class="admin-wrapper">
    <div class="admin-table-header">
      <el-button @click="openCreateDialog" type="primary">Добавить пункт</el-button>
    </div>
    <div class="admin-table-wrapper">
      <el-table
          v-loading="loading"
          class="admin-table"
          :data="filteredList"
          stripe>
        <el-table-column
            prop="id"
            label="#"
            width="60">
        </el-table-column>
        <el-table-column
            prop="translations.ru.title"
            label="Заголовок статьи RU"
        >
        </el-table-column>
        <el-table-column
            prop="translations.kz.title"
            label="Заголовок статьи KZ"
        >
        </el-table-column>
        <el-table-column
            prop="translations.en.title"
            label="Заголовок статьи EN"
        >
        </el-table-column>
        <el-table-column
            label="Видимость"
        >
          <template #default="scope">
            <toggle-visibility-btn :id="scope.row.id" :value="scope.row.show"/>
          </template>
        </el-table-column>
        <el-table-column
            label="Операции"
            width="130"
            fixed="right">
          <template #default="scope">
            <edit-btn :id="scope.row.id" :show="true" />
            <delete-btn :id="scope.row.id" :show="true"/>
          </template>
        </el-table-column>
      </el-table>
      <create-edit-dialog />
    </div>
  </div>
</template>
<script>
import articles from '@/mixins/articles'
import CreateEditDialog from '@/components/Articles/CreateEditDialog'
import DeleteBtn from '@/components/Articles/DeleteBtn'
import EditBtn from '@/components/Articles/EditBtn'
import ToggleVisibilityBtn from '@/components/Articles/ToggleVisibilityBtn'

export default {
  components: {CreateEditDialog, EditBtn, DeleteBtn, ToggleVisibilityBtn},
  mixins: [articles],
  data(){
    return {
      loading: false,
    }
  },
  mounted(){
    this.loading = true
    this.loadList().then(() => setTimeout(() => this.loading = false, 100))
  }
}
</script>